module.exports = "../study/imgs/maps/Nagano/S8/Climate/Temperture/Nagano_Temperture_GFDL_RCP45_Mid.png";